import Vue from "vue";

const getDefaultState = () => {
  return {
    badges: [], // used to display badges on profile, etc.
    unawardedBadges: [], // used to display badge award modal
  };
};

const state = Vue.observable(getDefaultState());

const methods = {
  RESET_STATE() {
    Object.assign(state, getDefaultState());
  },

  setUserBadges(badges) {
    state.badges = badges;
  },

  clearUserBadges() {
    state.badges = [];
  },

  setUnawardedBadges(badges) {
    state.unawardedBadges = badges;
  },

  clearUnawardedBadges() {
    state.unawardedBadges = [];
  },
};

const BadgeStore = {
  state,
  methods,
};
export default BadgeStore;
